import { app } from '../../../../app';
import { Controller } from './oidc-endpoints.controller';

app.component('oidcEndpoints', {
    bindings: {
        clientId: '<',
        credentials$: '<',
    },
    controller: Controller,
    templateUrl: require('./oidc-endpoints.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/oidc-endpoints/oidc-endpoints.component.js